export enum PassengerType { ADT, CHD, INF }

export interface IPaxFare {
    passengerType?: PassengerType;
    quantity?: number;
    unitRequiredPoint?: number;
    travelerRefNumbers?: string[];
    unitFare?: number;
    unitPrice?: number;
    tax?: number;
    surcharge?: number;
    total?: number;
}
